import { render, staticRenderFns } from "./ScoreTables.vue?vue&type=template&id=b3223aea&scoped=true"
import script from "./ScoreTables.vue?vue&type=script&lang=js"
export * from "./ScoreTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3223aea",
  null
  
)

export default component.exports